import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../components/firebase.js";
import { getDocs, collection } from "firebase/firestore";

import Hr22 from "../images/chooseUs/6.jpeg";
import Hr1 from "../images/faq/hr1.jpeg";
import Hr2 from "../images/faq/hr2.jpeg";
import Hr3 from "../images/faq/hr3.jpg";
import Hr4 from "../images/faq/hr4.jpg";
import Hr5 from "../images/faq/hr5.jpg";
import Hr6 from "../images/faq/hr6.jpg";
import Hr7 from "../images/faq/hr7.jpg";
import Pr8 from "../images/faq/pr8.jpeg";


import BookCar from "./BookCar.jsx";
import BookCar1hr from "./BookCar1hr.jsx";
import BookCarMid from "./BookCarMid.jsx";



function PickCar() {
  const [cars, setCars] = useState([
    {
      air: "Guided tour of the area",
      img: Hr1,
      name: "1 hour guided tour",
      price: "140",
      fuel:'1 hr'
    },
    {
      air: "Guided tour of the area",
      img: Hr2,
      name: "2 hour guide tour",
      price: "280",
      fuel:'2 hr'
    },

    /*
    {
      air: "Guided Tour with the best on Island, Visiting all the good spots",
      img: Hr3,
      name: "Dj Khaled Pull up",
      price: "500",
       fuel:'2 hr'
    },

    {
      air: "Private tour with James Harden",
      img: Hr4,
      name: "James Harden Pull up",
      price: "500",
       fuel:'2 hr'
    },

    {
      air: "Private Tour with Ja Rule",
      img: Hr7,
      name: "Ja Rule pull up",
      price: "500",
       fuel:'2 hr'
    },

    {
      air: "Private Tour with lil durk",
      img: Hr6,
      name: "Lil Durk pull up",
      price: "500",
       fuel:'2 hr'
    },

    {
      air: "Private tour with Polo G",
      img: Hr5,
      name: "Polo G pull up ",
      price: "500",
      fuel:'2 hr'
    },
 */

  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [isModalOpenz, setIsModalOpenz] = useState(false);
  const openModalz = () => setIsModalOpenz(true);
  const closeModalz = () => setIsModalOpenz(false);


  const [isModalOpens, setIsModalOpens] = useState(false);
  const openModals = () => setIsModalOpens(true);
  const closeModals = () => setIsModalOpens(false);

  const call = () => {
    const phoneNumber = "+16493413819";
    window.location.href = `tel:${phoneNumber}`;
  };


  const colStyle = {
    position: 'relative',
    height: '350px',
    marginBottom: '85px', // Space between stacked cards in mobile view
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%' // Make each card occupy full width
    ,  zIndex: 2,
  };
  
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const [isExpanded2, setIsExpanded2] = useState(false);

  const toggleExpand2 = () => {
    setIsExpanded2((prev) => !prev);
  };

  const scrollToCelebGallery = () => {
    const celebGalleryElement = document.getElementById("atvgallery");
    if (celebGalleryElement) {
      celebGalleryElement.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <section id="pick-section" className="pick-section" style={{ marginTop: '-100px', marginBottom: '70px' }}>
      <div className="container">
        <div className="pick-container__title">
          <h2>Atv Tours</h2>
          <p>We offer a range of Atv tour packages so our clients can have the maximum fun.</p>

          <p>
        <a
          href="#atvgallery" // Fallback for non-JavaScript environments
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            scrollToCelebGallery(); // Smooth scroll to the element
          }}
          style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
        >
          View ATV gallery
        </a>
      </p>

        </div>
  
        <div className="row">
          {/* Card 1 */}
 <div className="col-12 col-md-6" style={{ ...colStyle, paddingRight: '10px' }}>
  <div
    className="models-div__box"
    style={{
      backgroundColor: "black",
      borderRadius: "8px",
      transition: "transform 0.3s ease",
      boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
      overflow: "hidden",
      cursor: "pointer",
      width: '95%',
      position: 'relative',
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <div className="models-div__box__img" style={{ position: 'relative' }}>
      <img
        src={Hr1}
        alt="car_img"
        style={{
          height: "250px",
          width: "100%",
          backgroundColor: 'white',
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      />
      <div
        className="models-div__box__img-overlay"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          padding: "5px 10px",
          borderRadius: "5px",
          color: "#fff",
          fontSize: "16px",
          fontWeight: "bold",
          color: 'white',
          zIndex: 1 // Ensure overlay stays above image and does not shift
        }}
      >
        1 Hour Guided Tour
      </div>
    </div>
    <div className="models-div__box__descr" style={{ padding: "15px" }}>
      <div
        className="models-div__box__descr__price"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h4
          style={{
            margin: "5px 10px 5px 0",
            color: "white",
            fontSize: "24px",
          }}
        >
          $140 - $160
        </h4>
        <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>
          for 1 hr
        </p>
      </div>
      <div className="models-div__box__descr__details">
      <span style={{ fontSize: "11px", margin: "2px", color: 'white' }}>
        {isExpanded
          ? `We visit the Look out Spot, The Cave and the Hole for one hour! 
             All tours are with Complimentary water and a Guide to make sure 
             you feel very safe on the roads with us, please note we go on road 
             and then off roads to get the best experience.`
          : `We visit the Look out Spot...`}
      </span>
      <button
        onClick={toggleExpand}
        style={{
          backgroundColor: "transparent",
          color: "#FFD700",
          border: "none",
          cursor: "pointer",
          fontSize: "11px",
          marginLeft: "5px",
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
      </div>
      <button
        className="models-div__box__descr__btn"
        style={{
          height: "40px",
          width: "100%",
          background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          marginTop: "10px",
          transition: "background-color 0.3s ease",
          fontSize: "15px",
          color: 'white',
        }}
        onClick={openModals}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#20a4f3")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#B8860B")}
      >
        Reserve Now
      </button>
    </div>
  </div>
</div>

          {/* Card 2 */}
  <div className="col-12 col-md-6" style={{ ...colStyle, paddingRight: '10px' }}>
  <div
    className="models-div__box"
    style={{
      backgroundColor: "black",
      borderRadius: "8px",
      transition: "transform 0.3s ease",
      boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
      overflow: "hidden",
      cursor: "pointer",
      width: '95%',
      position: 'relative'
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <div className="models-div__box__img" style={{ position: 'relative' }}>
      <img
        src={Pr8}
        alt="car_img"
        style={{
          height: "250px",
          width: "100%",
          backgroundColor: 'white',
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      />
      <div
        className="models-div__box__img-overlay"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          padding: "5px 10px",
          borderRadius: "5px",
          color: "#fff",
          fontSize: "16px",
          fontWeight: "bold",
          color: 'white',
          zIndex: 1 // Ensure overlay stays above image and does not shift
        }}
      >
        1.5 Hour Guided Tour
      </div>
    </div>


    <div className="models-div__box__descr" style={{ padding: "15px" }}>
      <div
        className="models-div__box__descr__price"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h4
          style={{
            margin: "5px 10px 5px 0",
            color: "white",
            fontSize: "24px",
          }}
        >
          $205 - $235
        </h4>
        <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>
          for 1.5 hr
        </p>
      </div>
      <div className="models-div__box__descr__details">
      <span style={{ fontSize: "11px", margin: "2px", color: 'white' }}>
        {isExpanded2
          ? `We visited the Beach , The Look out spot and The Cave/ Hole with complimentary water for all them time.`
          : `We visited the Beach..`}
      </span>
      <button
        onClick={toggleExpand2}
        style={{
          backgroundColor: "transparent",
          color: "#FFD700",
          border: "none",
          cursor: "pointer",
          fontSize: "11px",
          marginLeft: "5px",
        }}
      >
        {isExpanded2 ? "Read Less" : "Read More"}
      </button>
      </div>
      <button
      
        className="models-div__box__descr__btn"
        style={{
          height: "40px",
          width: "100%",
          background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          marginTop: "10px",
          transition: "background-color 0.3s ease",
          fontSize: "15px",
          color: 'white',
        }}
        onClick={openModalz}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#20a4f3")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#B8860B")}
      >
        Reserve Now
      </button>
     
    </div>
  </div>
</div>  


 <div className="col-12 col-md-6" style={{ ...colStyle, paddingRight: '10px' }}>
  <div
    className="models-div__box"
    style={{
      backgroundColor: "black",
      borderRadius: "8px",
      transition: "transform 0.3s ease",
      boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
      overflow: "hidden",
      cursor: "pointer",
      width: '95%',
      position: 'relative'
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <div className="models-div__box__img" style={{ position: 'relative' }}>
      <img
        src={Hr2}
        alt="car_img"
        style={{
          height: "250px",
          width: "100%",
          backgroundColor: 'white',
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      />
      <div
        className="models-div__box__img-overlay"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          padding: "5px 10px",
          borderRadius: "5px",
          color: "#fff",
          fontSize: "16px",
          fontWeight: "bold",
          color: 'white',
          zIndex: 1 // Ensure overlay stays above image and does not shift
        }}
      >
        2 Hour Guided Tour
      </div>
    </div>

    
    <div className="models-div__box__descr" style={{ padding: "15px" }}>
      <div
        className="models-div__box__descr__price"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h4
          style={{
            margin: "5px 10px 5px 0",
            color: "white",
            fontSize: "24px",
          }}
        >
          $280 - $320
        </h4>
        <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>
          for 2 hr
        </p>
      </div>
      <div className="models-div__box__descr__details">
      <span style={{ fontSize: "11px", margin: "2px", color: 'white' }}>
        {isExpanded2
          ? `We visited the Beach , The Look out spot and The Cave/ Hole with complimentary water for all them time.`
          : `We visited the Beach..`}
      </span>
      <button
        onClick={toggleExpand2}
        style={{
          backgroundColor: "transparent",
          color: "#FFD700",
          border: "none",
          cursor: "pointer",
          fontSize: "11px",
          marginLeft: "5px",
        }}
      >
        {isExpanded2 ? "Read Less" : "Read More"}
      </button>
      </div>
      <button
      
        className="models-div__box__descr__btn"
        style={{
          height: "40px",
          width: "100%",
          background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          marginTop: "10px",
          transition: "background-color 0.3s ease",
          fontSize: "15px",
          color: 'white',
        }}
        onClick={openModal}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#20a4f3")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#B8860B")}
      >
        Reserve Now
      </button>
     
    </div>
  </div>
</div> 

<div className="col-12 col-md-6" style={{ ...colStyle, paddingRight: '10px' }}>
  <div
    className="models-div__box"
    style={{
      backgroundColor: "black",
      borderRadius: "8px",
      transition: "transform 0.3s ease",
      boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
      overflow: "hidden",
      cursor: "pointer",
      width: '95%',
      position: 'relative',
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <div className="models-div__box__img" style={{ position: 'relative' }}>
      <img
        src={Hr22}
        alt="car_img"
        style={{
          height: "250px",
          width: "100%",
          backgroundColor: 'white',
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          objectFit: "cover"
        }}
      />
      <div
        className="models-div__box__img-overlay"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          padding: "5px 10px",
          borderRadius: "5px",
          color: "#fff",
          fontSize: "16px",
          fontWeight: "bold",
          color: 'white',
          zIndex: 1 // Ensure overlay stays above image and does not shift
        }}
      >
        3 Hour Guided Tour
      </div>
    </div>
    <div className="models-div__box__descr" style={{ padding: "15px" }}>
      <div
        className="models-div__box__descr__price"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h4
          style={{
            margin: "5px 10px 5px 0",
            color: "white",
            fontSize: "24px",
          }}
        >
          Arranged On Demand
        </h4>
        <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>
          
        </p>
      </div>
      <div className="models-div__box__descr__details">
      <span style={{ fontSize: "11px", margin: "2px", color: 'white' }}>
        {isExpanded
          ? `We visit the Height Mountain Over looking the entire Turks and Caicos Islands viewing the Caribbean Ocean then off to the South West to See the Starting of Atlantic Ocean to ride on the Beach, then back to the Hole and Cave it’s a very interesting ride to see 80% of the island on ATVs `
          : `We visit the Height Mountain...`}
      </span>
      <button
        onClick={toggleExpand}
        style={{
          backgroundColor: "transparent",
          color: "#FFD700",
          border: "none",
          cursor: "pointer",
          fontSize: "11px",
          marginLeft: "5px",
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
      </div>
      <button
        className="models-div__box__descr__btn"
        style={{
          height: "40px",
          width: "100%",
          background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          marginTop: "10px",
          transition: "background-color 0.3s ease",
          fontSize: "15px",
          color: 'white',
        }}
        onClick={call}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#20a4f3")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#B8860B")}
      >
        Call Us To Book
      </button>
    </div>
  </div>
</div>

        </div>





      </div>

      <BookCar1hr isModalOpen={isModalOpens} closeModal={closeModals} />
      <BookCar isModalOpen={isModalOpen} closeModal={closeModal} />
      <BookCarMid isModalOpen={isModalOpenz} closeModal={closeModalz} />

    </section>
  );



}

export default PickCar;
